module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"รายการ Drone ที่อยู่ระหว่างผลิต","page.description":"รายการของ Drone ที่ถูกผลิต โดยรับข้อมูลมาจาก HGDKit ซึ่งนำข้อมูลมาจากโรงงาน โดยผู้ใช้งานจะต้องทำการระบุ Lot และทำการ Approve เพื่อนำข้อมูลเหล่านี้เพิ่มเป็นฐานข้อมูลของ Drone ใหม่","manufacture.manufacturer.title":"ข้อมูลการผลิตจาก โรงงาน {code}","manfacture.empty":"ไม่มีข้อมูลการผลิต Drone ชุดใหม่"}}')
  delete Component.options._Ctor
}
